import { render, staticRenderFns } from "./voiceList.vue?vue&type=template&id=0b05e1c9&scoped=true&"
import script from "./voiceList.vue?vue&type=script&lang=js&"
export * from "./voiceList.vue?vue&type=script&lang=js&"
import style0 from "./voiceList.vue?vue&type=style&index=0&id=0b05e1c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05e1c9",
  null
  
)

export default component.exports